import React from "react"
import { PlayerIdentity } from "components/ReviewAudit/PublicRatings"
import { accountNumber, participantKey } from "../../../components/participantIdentity"
import { seedless } from "../../../components/seeds"
import { withChildPlace } from "../../../components/participantDisplay"
import { placeLabel } from "../../Entries/Tenis10ChildEntryModal"
// P54: a child (Tenis10) never shows a seed.
export const Seed = ({ person }) => person.seeded && !seedless(person) ? <span className="main-draw-seed" aria-label={`Seed ${person.competitionRank ?? "—"}`}>[{person.competitionRank ?? "—"}]</span> : null
const Name = ({ person }) => ['BYE', 'TBD', 'PENDING'].includes(person?.type) ? person.type : <PlayerIdentity player={person} to={person?.id ? `/accounts/players/${person.id}` : null} linkProps={{ target: "_blank", rel: "noopener noreferrer" }}>{[person?.firstName, person?.lastName].filter(Boolean).join(' ') || '—'}{person && <Seed person={person} />}{accountNumber(person) != null && ` #${accountNumber(person)}`}</PlayerIdentity>
// P73 (Tudor 2026-10-29): a child's place under its name (withChildPlace), as on its Entries row
const ChildPlace = ({ person, competition }) => {
  const place = placeLabel(withChildPlace(person, competition)?.place)
  return place ? <div className="text-muted small" data-testid="child-place">
    <i className="bx bx-map mr-1" aria-hidden="true" /><span className="sr-only">Location: </span>{place}
  </div> : null
}
export default function GroupList({ group = [], competition }) {
  return (
    <table className="main-draw-group-standings" aria-label="Group standings">
      <thead>
        <tr>
          <th>Place</th>
          <th>Participant</th>
          <th>Wins</th>
        </tr>
      </thead>
      <tbody>
        {group.map((person, i) => (
          <tr key={participantKey(person) ?? `placeholder:${i}`}>
            <td>{i + 1}</td>
            <td>
              <Name person={person} />
              <ChildPlace person={person} competition={competition} />
              {person.partner && (
                <div>
                  <Name person={person.partner} />
                </div>
              )}
            </td>
            <td>{person.wins ?? "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
